<div>
  <section class="content-header">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1 class="small"><i class="fas fa-camera"></i> カメラ一覧</h1>
        </div>
      </div>
    </div>
  </section>
  <section class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <gs-grid></gs-grid>
        </div>
      </div>
    </div>
  </section>
</div>
